/* eslint-disable no-unused-vars, no-return-assign */

import _ from 'lodash';

import z from 'app/common/z';

const getAllowedNextActionTypes = () => [
  'write',
  'search',
  'filter',
  'paths_group',
];

/* Only allowing creation of write steps, which can then be changed into
 * search steps.
 */
export const stepTypes = {
  read: {
    label: 'Trigger',
    blurb: 'Trigger',
    isNode: true,
    allowedNextTypes: getAllowedNextActionTypes,
  },

  write: {
    label: 'Action',
    blurb: 'Action',
    isNode: true,
    allowedNextTypes: getAllowedNextActionTypes,
  },

  search: {
    label: 'Search',
    blurb: 'Search',
    isNode: true,
    allowedNextTypes: getAllowedNextActionTypes,
  },

  search_or_write: {
    label: 'Search or Create',
    blurb: 'Search or Create',
    isNode: true,
    allowedNextTypes: getAllowedNextActionTypes,
  },

  filter: {
    label: 'Filter',
    blurb: 'Filter',
    isNode: true,
    api: 'FilterAPI',
    allowedNextTypes: getAllowedNextActionTypes,
  },

  begin: {
    allowedNextTypes() {
      return ['read'];
    },
  },

  activate: {
    allowedNextTypes() {
      return [];
    },
    blurb: 'Activate',
  },

  end: {
    allowedNextTypes() {
      return [];
    },
  },

  paths_group: {
    label: 'Paths',
    blurb: 'Paths',
    isNode: true,
    api: 'BranchingAPI',
    allowedNextTypes: () => [],
  },
};

const createStep = (type, options) => {
  return _.extend(
    {
      isBegin: false,
      isEnd: false,
    },
    options,
    {
      type,
      isNode: (stepTypes[type] && stepTypes[type].isNode) || false,
    }
  );
};

const BEGIN_STEP = createStep('begin', {
  isBegin: true,
});

const END_STEP = createStep('end', { isEnd: true });

const Step = {
  create: createStep,

  begin() {
    return BEGIN_STEP;
  },

  end() {
    return END_STEP;
  },

  allowedTypesBetween(prevStep, nextStep) {
    return stepTypes[prevStep.type].allowedNextTypes();
  },

  doesAllowTypeBetween(type, prevStep, nextStep) {
    return Step.allowedTypesBetween(prevStep, nextStep).indexOf(type) >= 0;
  },

  label(stepOrType) {
    if (_.isObject(stepOrType)) {
      return stepOrType.type;
    }
    return stepTypes[stepOrType].label;
  },

  blurb(stepOrType) {
    if (_.isObject(stepOrType)) {
      return stepOrType.type;
    }
    return stepTypes[stepOrType].blurb;
  },

  nodeStepBefore(steps, stepIndex) {
    const stepsBefore = steps.slice(0, stepIndex).reverse();
    return _.find(stepsBefore, step => step.isNode);
  },

  nodeStepAfter(steps, stepIndex) {
    const stepsAfter = steps.slice(stepIndex);
    return _.find(stepsAfter, step => step.isNode);
  },
};

export default Step;
